import { GetServerSidePropsContext } from 'next'
import NotFound from 'next/dist/client/components/not-found-error'
import { NextSeo } from 'next-seo'
import React from 'react'
import { articleApi } from '@/api/unban/articleApi'
import { CONTENTS_PATH } from '@/constants/routes'
import ArticlePanel from '@/features/article/components/ArticlePanel'
import DefaultLayout from '@/features/common/components/layouts/DefaultLayout'
import ArticleModel from '@/features/common/models/articleModel'
import ArticlesModel from '@/features/common/models/articlesModel'
import { ArticleModelMapper } from '@/features/common/mappers/ArticleModelMapper'
import CategoryType from '@models/categoryType'
import { ServerSideUtils } from '@/utils/serverSideUtils'

interface IProps {
  content?: ArticleModel
  relatedContents?: ArticlesModel
}

function Content({ content, relatedContents }: IProps) {
  if (!content) {
    return (
      <DefaultLayout>
        <NotFound />
      </DefaultLayout>
    )
  }

  return (
    <>
      <NextSeo
        title={`${content?.title?.replace('<br/>', ' ')}`}
        description={`${content?.description}`}
        canonical={`${process.env.NEXT_PUBLIC_UNBAN_WEB_URL}/${CONTENTS_PATH}/${content?.id}`}
        openGraph={{
          url: `${process.env.NEXT_PUBLIC_UNBAN_WEB_URL}/${CONTENTS_PATH}/${content?.id}`,
          title: `${content?.title?.replace('<br/>', ' ')}`,
          description: `${content?.description}`,
          images: [
            {
              url: `${content?.ogImage}`,
              width: 1200,
              height: 630,
              alt: `${content?.title?.replace('<br/>', ' ')} - 이미지`,
              type: 'image/jpeg',
            },
          ],
        }}
      />
      <DefaultLayout>
        <ArticlePanel path={CONTENTS_PATH} articleModel={content} relatedArticlesModel={relatedContents} />
      </DefaultLayout>
    </>
  )
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
  try {
    const id = Number(ServerSideUtils.getUrlParam(context.query.id, '0'))

    if (!id) {
      return { props: {} }
    }

    const response = await articleApi.getArticle({ category: CategoryType.CONTENTS, id })
    const result = response.data?.result

    return {
      props: {
        content: ArticleModelMapper.mapToPresentation(result?.article!!),
        relatedContents: ArticleModelMapper.mapsToPresentation(result?.relatedArticles!!),
      },
    }
  } catch (e) {
    return { props: {} }
  }
}

export default Content
